import { observer } from 'mobx-react-lite'
import { Box, EnumHelperText, HelperText, Switch, Typography, AutoFollowUp } from 'shared/ui'
import { LINK_AUTO_REMINDERS_LEARN_MORE } from 'shared/constants/links'
import { useChatbotContext } from 'pages/chatbot/context'
import styles from './styles.module.scss'

export const FallbackSettings = observer(() => {
  const {
    model: { settings },
    errors,
  } = useChatbotContext()
  const {
    followUpWindow,
    followUpAssertiveness,
    setFollowUpWindow,
    setFollowUpAssertiveness,
    autoFollowUpEnabled,
    onAutoFollowUpToggle,
  } = settings

  const followUpWindowError = errors.getError('settings.followup_window')

  return (
    <section className={styles.container}>
      <Box display={'flex'}>
        <Box display={'flex'} flexDirection={'column'} flexGrow={'1'}>
          <Typography variant={'body-lg-medium'} ariaLabel={'AutoFollowUp'}>
            Auto FollowUp™
          </Typography>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'AutoFollowUpDesc'}
            color={'var(--content-primary-secondary)'}
            marginTop={4}
          >
            AI-powered follow-ups to maximize engagement.{' '}
            <a
              href={LINK_AUTO_REMINDERS_LEARN_MORE}
              target={'_blank'}
              rel='noreferrer'
              className={styles.learnMoreLink}
            >
              Learn more
            </a>
          </Typography>
        </Box>
        <Box paddingLeft={'20px'} paddingTop={'4px'}>
          <Switch value={autoFollowUpEnabled} onChange={onAutoFollowUpToggle} size='middle' />
        </Box>
      </Box>
      {autoFollowUpEnabled && (
        <AutoFollowUp
          followUpWindow={followUpWindow}
          followUpAssertiveness={followUpAssertiveness}
          setFollowUpWindow={setFollowUpWindow}
          setFollowUpAssertiveness={setFollowUpAssertiveness}
        />
      )}
      {autoFollowUpEnabled && !!followUpWindowError && (
        <HelperText
          icon={'alertTriangleSmall'}
          variant={EnumHelperText.Error}
          text={followUpWindowError}
        />
      )}
    </section>
  )
})
